import { Dialog, DialogContent } from '@/components/ui/dialog';
import { ProfileCreateForm } from '../ProfileView/ProfileForms';
import { DialogTitle } from '@radix-ui/react-dialog';

export interface ProfileCreateDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    disabled?: boolean;
    onSubmit: (telephone: string) => void;
}

export function ProfileCreateDialog({
    open,
    onOpenChange,
    disabled,
    onSubmit,
}: ProfileCreateDialogProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md p-5" aria-describedby={undefined}>
                <DialogTitle className="hidden" />
                <ProfileCreateForm
                    disabled={disabled}
                    onSubmit={onSubmit}
                />
            </DialogContent>
        </Dialog>
    );
}
